import React from 'react';
import { Modal } from 'react-bootstrap';
import { DocumentPreviewState } from '../../utils/documentPreview';

interface DocumentPreviewModalProps {
  state: DocumentPreviewState;
  onClose: () => void;
}

/**
 * Modal de visualização de documento (PDF/imagem) direto no navegador, sem
 * download prévio (E5). Ver hooks/useDocumentPreview para o estado/fetch.
 */
const DocumentPreviewModal: React.FC<DocumentPreviewModalProps> = ({ state, onClose }) => {
  return (
    <Modal show={state.show} onHide={onClose} size="lg" centered scrollable>
      <Modal.Header closeButton>
        <Modal.Title style={{ fontSize: '16px', wordBreak: 'break-all' }}>{state.title}</Modal.Title>
      </Modal.Header>
      <Modal.Body style={{ textAlign: 'center' }}>
        {state.url && state.kind === 'image' && (
          <img
            src={state.url}
            alt={state.title}
            style={{ maxWidth: '100%', maxHeight: '75vh' }}
          />
        )}
        {state.url && state.kind === 'pdf' && (
          <iframe
            title={state.title}
            src={state.url}
            style={{ width: '100%', height: '75vh', border: 'none' }}
          />
        )}
      </Modal.Body>
    </Modal>
  );
};

export default DocumentPreviewModal;
